import { styled } from '@mui/material/styles';
import { Box, IconButton } from '@mui/material';

export const scrollWrapperStyles = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflow: 'auto',
  display: 'flex',
  justifyContent: 'center',
  padding: '20px',
  '@media (max-width: 600px)': {
    padding: '10px',
  },
};

export const ModalContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '90%',
  maxWidth: '1200px',
  margin: 'auto',
  boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.35)',
  borderRadius: '30px',
  display: 'flex',
  flexDirection: 'column',
  padding: '60px 30px 0px',
  background: `
    linear-gradient(
      90deg,
      #e6ebf0 0%,
      rgba(232, 231, 234, 0.67) 5%,
      rgba(253, 254, 253, 1) 30%,
      rgba(253, 254, 253, 0.28) 50%,
      rgba(253, 254, 253, 1) 70%,
      rgba(232, 231, 234, 0.67) 95%,
      #e6ebf0 100%
    ),
    #ffffff
  `,
  [theme.breakpoints.down('sm')]: {
    padding: '65px 0px 15px',
    width: '100%',
  },
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: 32,
  right: 32,
  zIndex: 10,
  width: '40px',
  height: '40px',
  color: '#492A18',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  transition: 'background-color 0.3s ease',
  '&:hover': {
    backgroundColor: 'rgba(234, 230, 218, 1)',
  },
  [theme.breakpoints.down('sm')]: {
    top: 16,
    right: 16,
  },
}));

export const backdropStyles = {
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  backdropFilter: 'blur(4px)',
};

export const SectionHeadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 30,
  fontSize: '30px',
  fontWeight: 400,
  lineHeight: '30px',
  letterSpacing: '-1.2px',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: '26px',
    lineHeight: '28px',
    marginBottom: 24,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '22px',
    lineHeight: '26px',
    marginBottom: 20,
  },
}));
